<script lang="ts" setup>
	import { useDebounceFn } from '@vueuse/core'
	import type { ClassNameValue } from 'tailwind-merge'

	withDefaults(
		defineProps<{
			value?: string
			placeholder?: string
			inputClass?: ClassContext
			iconHeight?: number
			iconWidth?: number
			useCustomClass?: boolean
		}>(),
		{
			placeholder: 'search',
			useCustomClass: true
		}
	)

	const emits = defineEmits<{
		(arg: 'update:value', param: string): void
		(arg: 'change', param: string): void
	}>()
	const monitorInput = useDebounceFn((payload: Event) => {
		const input = payload.target as HTMLInputElement
		const inputValue = input.value.trim()
		emits('update:value', inputValue)
		emits('change', inputValue)
	}, 1000)

	const cls = computed(() => useAttrs()?.class ?? ('' as ClassNameValue))
</script>

<template>
	<div
		class=""
		:class="
			cn(
				'relative flex items-center gap-x-3 border-gray-300',
				useCustomClass ? 'rounded-lg border px-5' : '',
				cls
			)
		"
	>
		<slot name="prefix" />
		<slot name="icon-prefix">
			<tools-icon dir="line" icon="search-normal" :height="iconHeight" :width="iconWidth" />
		</slot>
		<input
			class="custom-input"
			:class="
				cn('w-full !border-none text-sm text-gray-600 placeholder-gray-400 placeholder:capitalize', inputClass)
			"
			type="search"
			:placeholder="placeholder"
			@input="monitorInput"
		/>
		<slot name="suffix" />
	</div>
</template>
